import { Component, OnInit, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Logo } from '../logo/logo';
import { SiteSettingsService } from '../../services/site-settings.service';

@Component({
	selector: 'app-footer',
	standalone: true,
	imports: [CommonModule, Logo],
	templateUrl: './footer.html',
	styleUrl: './footer.css',
})
export class Footer implements OnInit {
	currentYear = new Date().getFullYear();
	private settings = inject(SiteSettingsService);

	// Contact info — already loaded via APP_INITIALIZER
	contactPhone = signal(this.settings.val('contact', 'contact_phone', '+91 98765 43210'));
	contactEmail = signal(this.settings.val('contact', 'contact_email', 'contact@oghairstudio.com'));
	contactAddressLine1 = signal(this.settings.val('contact', 'contact_address_line1', 'Style On Studio'));
	contactAddressLine2 = signal(this.settings.val('contact', 'contact_address_line2', 'Hyderabad, Telangana, India'));

	quickLinks = [
		{ name: 'Home', route: '/' },
		{ name: 'Services', route: '/services' },
		{ name: 'About Us', route: '/about' },
		{ name: 'Contact', route: '/contact' }
	];

	services = [
		{ name: 'Hair Transplantation', route: '/services/hair-transplant' },
		{ name: 'PRP Therapy', route: '/services/prp-therapy' },
		{ name: 'Scalp Micropigmentation', route: '/services/smp' },
		{ name: 'Consultation', route: '/consultation' }
	];

	socialLinks = [
		{ name: 'Facebook', icon: 'facebook', url: '#' },
		{ name: 'Instagram', icon: 'instagram', url: '#' },
		{ name: 'Twitter', icon: 'twitter', url: '#' },
		{ name: 'LinkedIn', icon: 'linkedin', url: '#' }
	];

	ngOnInit() {}
}

